export default __webpack_public_path__ + "static/media/hockeyrink2.1220aad1.jpg";